import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDemoAuth } from '../../context/DemoAuthContext';
import './DemoLoginPage.css';

const DemoLoginPage = () => {
  const navigate = useNavigate();
  const { login, user } = useDemoAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // Check if user is already logged in and redirect
  useEffect(() => {
    if (user) {
      console.log('User already logged in, redirecting...');
      if (user.isAdmin) {
        navigate('/admin-demo', { replace: true });
      } else {
        navigate('/user-demo', { replace: true });
      }
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const result = await login(email, password);
      
      if (result.success) {
        // Redirect based on user type
        if (result.user.isAdmin) {
          navigate('/admin-demo');
        } else {
          navigate('/user-demo');
        }
      } else {
        setError(result.error);
      }
    } catch (err) {
      setError('Login failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleDemoLogin = (type) => {
    if (type === 'user') {
      setEmail('demo@oaklandai.com');
      setPassword('demo123');
    } else {
      setEmail('admin@oaklandai.com');
      setPassword('admin123');
    }
  };

  return (
    <div className="demo-login-container">
      <div className="demo-login-card">
        <div className="demo-login-header">
          <h1>Oakland AI Demo</h1>
          <p>Simple authentication system for demos</p>
        </div>

        <form onSubmit={handleSubmit} className="demo-login-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button 
            type="submit" 
            className="login-button"
            disabled={isLoading}
          >
            {isLoading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <div className="demo-credentials">
          <h3>Demo Credentials</h3>
          <div className="credential-buttons">
            <button 
              onClick={() => handleDemoLogin('user')}
              className="demo-credential-btn user"
            >
              Regular User
            </button>
            <button 
              onClick={() => handleDemoLogin('admin')}
              className="demo-credential-btn admin"
            >
              Admin User
            </button>
          </div>
          <div className="credential-info">
            <p><strong>Regular User:</strong> demo@oaklandai.com / demo123</p>
            <p><strong>Admin User:</strong> admin@oaklandai.com / admin123</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DemoLoginPage;
